<template>
  <div>
    <div class="oficina-tabs">
      <button
        v-for="tab in step.tabs"
        :key="tab.id"
        class="oficina-tab"
        :class="{ active: activeTab === tab.id }"
        @click="updateTab(tab.id)"
      >
        <i :class="getIconClass(tab.icon)"></i> {{ tab.label }}
      </button>
    </div>
    <div class="oficina-tab-content">
      <div v-if="activeTab === 'context'">
        <p class="oficina-slide-text" v-html="`&quot;${currentTabContent.replace(/\n/g, '<br>')}&quot;`"></p>
        <p v-if="currentTab.subtext" class="oficina-slide-subtext">{{ currentTab.subtext }}</p>
      </div>
      <div v-else-if="activeTab === 'video'">
        <div class="oficina-video-container">
          <iframe
            :src="`https://www.youtube.com/embed/${currentTab.videoId}?rel=0`"
            title="Tutorial eSUS Feedback"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="video-link-section">
          <span>Link direto do sistema:</span>
          <button
            type="button"
            class="oficina-btn-primary"
            @click="openEsusLink"
          >
            <i class="icofont-link"></i> Acessar eSUS
          </button>
        </div>
        <p v-if="currentTab.tip" class="oficina-slide-tip">
          <i class="icofont-info-circle"></i> {{ currentTab.tip }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabbedVideoSlide',
  props: {
    step: {
      type: Object,
      required: true,
    },
    activeTabs: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    activeTab() {
      return this.activeTabs.esus || 'context'
    },
    currentTab() {
      return this.step.tabs.find((t) => t.id === this.activeTab) || this.step.tabs[0]
    },
    currentTabContent() {
      return this.currentTab.content || ''
    },
  },
  methods: {
    updateTab(tabId) {
      this.$emit('update-tab', 'esus', tabId)
    },
    getIconClass(icon) {
      if (icon === 'Info') return 'icofont-info-circle'
      if (icon === 'Youtube') return 'icofont-youtube-play'
      return 'icofont-info-circle'
    },
    openEsusLink() {
      window.open('https://esusfeedback.com.br', '_blank')
    },
  },
  emits: ['update-tab'],
}
</script>

<style scoped>
.oficina-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.oficina-tabs::-webkit-scrollbar {
  height: 6px;
}

.oficina-tabs::-webkit-scrollbar-track {
  background: transparent;
}

.oficina-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.oficina-tabs::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.oficina-tab {
  padding: 12px 20px;
  border: 2px solid #e2e8f0;
  border-right: none;
  background: white;
  border-radius: 0;
  cursor: pointer;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.oficina-tab:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.oficina-tab:last-child {
  border-right: 2px solid #e2e8f0;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.oficina-tab:hover {
  border-color: #0FAFD7;
  color: #0FAFD7;
}

.oficina-tab.active {
  background: #0FAFD7;
  border-color: #0FAFD7;
  color: white;
  z-index: 1;
  position: relative;
}

.oficina-tab.active + .oficina-tab {
  border-left-color: #0FAFD7;
}

.oficina-tab-content {
  min-height: 400px;
}

.oficina-slide-text {
  font-size: 16px;
  line-height: 1.6;
  color: #1e293b;
  margin-bottom: 24px;
}

.oficina-slide-subtext {
  font-size: 14px;
  color: #64748b;
  margin-top: 16px;
}

.oficina-video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  margin-bottom: 16px;
}

.oficina-video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.video-link-section {
  background: #eff6ff;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #bfdbfe;
  margin-top: 16px;
  flex-wrap: wrap;
}

.video-link-section span {
  color: #1e40af;
  font-weight: 600;
  flex: 1;
  min-width: 0;
}

.oficina-btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  flex-shrink: 0;
  background: #0FAFD7;
  color: white;
  border: none;
  cursor: pointer;
}

.oficina-slide-tip {
  background: #eff6ff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  margin-top: 24px;
  color: #1e40af;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
</style>
